import Footer from "../../components/Footer/Footer";
import { localLegalInfo } from "../../components/utils/local.policy";
import { getStore } from "../../services/backend/serverSideProps";
import styles from "./terms.module.css";

export async function getServerSideProps(context) {
  return getStore(context);
}

const terms = (props) => {
  const { storeData } = props;
  var { terms } = storeData?.legalInfo || localLegalInfo;
  const storeName = storeData.storeName;
  terms = terms
    ?.replace(/{{shop name}}/g, storeName)
    .replace(/{{subdomain}}/g, storeData.subdomain);
  return (
    <div className={styles.container}>
      <main>
        <h2 className={styles.headline}>Terms & Conditions</h2>
        {terms.trim() != "" ? (
          <div className={styles.content} dangerouslySetInnerHTML={{ __html: terms }}></div>
        ) : null}
      </main>
      <Footer />
    </div>
  );
};

export default terms;
